import { createApi } from '@reduxjs/toolkit/query/react';
import { createExtendedTokenBaseQuery } from './baseQuery';

export interface StorageCorsConfig {
  allowed_origins: string[];
}

export interface StorageCorsApplyResult {
  organization: string;
  status: 'applied' | 'unsupported' | 'failed';
  detail?: string;
}

export interface StorageCorsApplyResponse {
  results: StorageCorsApplyResult[];
}

export interface StorageCorsApplyStartResponse {
  message: string;
  status: string;
  task_id: string;
}

export type CeleryTaskStatus = 'PENDING' | 'STARTED' | 'RETRY' | 'SUCCESS' | 'FAILURE';

export interface StorageCorsApplyStatusResponse {
  task_id: string;
  status: CeleryTaskStatus;
  result: StorageCorsApplyResponse | null;
  info?: string;
  error?: string;
  traceback?: string;
}

export const storageConfigApi = createApi({
  reducerPath: 'storageConfigApi',
  baseQuery: createExtendedTokenBaseQuery(''),
  tagTypes: ['StorageCorsConfig'],
  endpoints: (builder) => ({
    getCorsConfig: builder.query<StorageCorsConfig, void>({
      query: () => 'storage-config/cors/',
      providesTags: ['StorageCorsConfig'],
    }),
    updateCorsConfig: builder.mutation<StorageCorsConfig, StorageCorsConfig>({
      query: (data) => ({
        url: 'storage-config/cors/',
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['StorageCorsConfig'],
    }),
    applyCorsConfig: builder.mutation<StorageCorsApplyStartResponse, void>({
      query: () => ({
        url: 'storage-config/cors/apply/',
        method: 'POST',
      }),
    }),
    getCorsApplyStatus: builder.query<StorageCorsApplyStatusResponse, string>({
      // Generic Celery task-status endpoint (used for any async admin task, not storage-specific)
      query: (taskId) => `webhook/task/${taskId}/`,
    }),
  }),
});

export const {
  useGetCorsConfigQuery,
  useUpdateCorsConfigMutation,
  useApplyCorsConfigMutation,
  useGetCorsApplyStatusQuery,
} = storageConfigApi;
